import React from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { Form } from "react-final-form";
import { useMergeContactModalStore } from "../store/useMergeContactModalStore";
import { MERGE_CONTACT_FORM_KEYS } from "../constants/MergeContactFormModal.constant";
import { TextSuggestionField } from "./components/TextSuggestionField";

export const MergeContactFormModal = () => {
  const open = useMergeContactModalStore((state) => state.openFormModal);
  const setOpenModal = useMergeContactModalStore(
    (state) => state.setOpenFormModal
  );
  const setOpenConfirmationModal = useMergeContactModalStore(
    (state) => state.setOpenConfirmationModal
  );
  const mergedContactDetailsForm = useMergeContactModalStore(
    (state) => state.mergedContactDetailsForm
  );

  const handleSubmit = () => {
    setOpenModal(false);
    setOpenConfirmationModal(true);
  };

  return (
    open && (
      <>
        <Form onSubmit={handleSubmit} initialValues={mergedContactDetailsForm}>
          {({ handleSubmit }) => {
            return (
              <form onSubmit={handleSubmit}>
                <ExlyModal
                  title="Verify details of the new merged profile"
                  open={open}
                  onClose={() => setOpenModal(false)}
                  primaryBtnText="Merge profiles"
                  modal_props={{
                    primaryBtnClassName: "!tw-w-full",
                    secondaryBtnClassName:
                      "!tw-font-medium !tw-border-[1.5px] !tw-border-solid !tw-rounded-[5px] !tw-border-[#272522] !tw-w-full hover:!tw-bg-transparent",
                  }}
                  primaryBtnProps={{
                    buttonWrapperClassName: "!tw-w-full",
                  }}
                  secondaryBtnProps={{
                    buttonWrapperClassName: "!tw-w-full",
                  }}
                  onPrimaryBtnClick={handleSubmit}
                  className="!tw-overflow-x-hidden !tw-min-w-[600px]"
                  showSecondaryBtn
                  onSecondaryBtnClick={() => setOpenModal(false)}
                >
                  <div className="tw-p-[16px_24px_20px_24px] max-[767px]:tw-p-[16px_16px_20px_16px]">
                    <div className={`tw-mb-6`}>
                      <div className="tw-text-[14px] tw-font-medium tw-tracking-[0.28px] tw-text-[#000000D9] tw-mb-[10px]">
                        Name
                      </div>
                      <TextSuggestionField
                        fieldKey={MERGE_CONTACT_FORM_KEYS.NAME}
                      />
                      <div className="tw-mt-4">
                        <div className="tw-text-[14px] tw-font-medium tw-tracking-[0.28px] tw-text-[#000000D9]">
                          Email ID
                        </div>
                        <TextSuggestionField
                          fieldKey={MERGE_CONTACT_FORM_KEYS.EMAIL_ID}
                        />
                      </div>

                      <div className="tw-my-2">
                        <div className="tw-text-[14px] tw-font-medium tw-tracking-[0.28px] tw-text-[#000000D9] tw-mb-[10px]">
                          Phone no.
                        </div>
                        <TextSuggestionField
                          fieldKey={MERGE_CONTACT_FORM_KEYS.PHONE_NUMBER}
                        />
                      </div>
                      <div className="tw-my-2">
                        <div className="tw-text-[14px] tw-font-medium tw-tracking-[0.28px] tw-text-[#000000D9] tw-mb-[10px]">
                          Instagram username
                        </div>
                        <TextSuggestionField
                          fieldKey={MERGE_CONTACT_FORM_KEYS.INSTAGRAM_USERNAME}
                        />
                      </div>
                    </div>
                  </div>
                </ExlyModal>
              </form>
            );
          }}
        </Form>
      </>
    )
  );
};
